// extracted by mini-css-extract-plugin
export default {"section":"WelcomeBanner_section__yEAEp","title":"WelcomeBanner_title__LyNFX","appEntry":"WelcomeBanner_appEntry__ePpWP","appGrid":"WelcomeBanner_appGrid__B9VUf"};